// extracted by mini-css-extract-plugin
export var animationContainer = "_h6-0";
export var asteriskIcon = "_h6-8";
export var conversationLeftSection = "_h6-4";
export var conversationListItem = "_h6-3";
export var conversationMiddleSection = "_h6-5";
export var conversationRightSection = "_h6-6";
export var detailsContent = "_h6-1";
export var listContainer = "_h6-7";
export var modalContent = "_h6-2";